module.exports = __webpack_public_path__ + "img/youtube.c83d2c53.svg";